import { Link } from 'react-router-dom';

const courses = [
  {
    title: '美容マーケティング基礎講座',
    desc: 'SNSを活用した美容ビジネスのマーケティング基礎を学ぶ入門コース。',
    img: 'https://readdy.ai/api/search-image?query=elegant%20beauty%20marketing%20course%20online%20learning%20desk%20with%20cosmetics%20flowers%20soft%20light%20minimal%20clean%20white%20background&width=400&height=260&seq=course1&orientation=landscape',
    duration: '全6回',
    level: '初級',
  },
  {
    title: 'ブランディング戦略セミナー',
    desc: '美容ブランドの価値を高めるブランディング戦略を実践的に学びます。',
    img: 'https://readdy.ai/api/search-image?query=beauty%20branding%20strategy%20seminar%20workshop%20elegant%20feminine%20soft%20pastel%20background%20cosmetics&width=400&height=260&seq=course2&orientation=landscape',
    duration: '1日集中',
    level: '中級',
  },
  {
    title: 'SNS運用マスター講座',
    desc: 'Instagram・TikTokを使った美容コンテンツ制作と集客を徹底解説。',
    img: 'https://readdy.ai/api/search-image?query=social%20media%20content%20creation%20beauty%20influencer%20elegant%20phone%20camera%20soft%20light%20pastel%20minimal&width=400&height=260&seq=course3&orientation=landscape',
    duration: '全8回',
    level: '初〜中級',
  },
];

export default function CoursesSection() {
  return (
    <section className="py-24 bg-sky-50/50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-sky-400 text-xs font-medium tracking-widest uppercase">Courses &amp; Seminars</span>
          <h2 className="text-3xl md:text-4xl font-light text-slate-800 mt-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            講座・<span className="font-semibold">セミナー</span>
          </h2>
          <div className="w-12 h-0.5 bg-sky-300 mx-auto mt-5"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {courses.map((c) => (
            <div key={c.title} className="bg-white rounded-2xl overflow-hidden hover:scale-[1.02] transition-transform duration-300 cursor-default">
              <div className="relative h-48 overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-sky-400/10"></div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-sky-400 border border-sky-200 px-2 py-0.5 rounded-full">{c.duration}</span>
                  <span className="text-xs text-slate-400 border border-slate-200 px-2 py-0.5 rounded-full">{c.level}</span>
                </div>
                <h3 className="text-base font-semibold text-slate-800 mb-2">{c.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
}
